module.exports = __webpack_public_path__ + "img/chart-pyramid.e3c35b1f.svg";